
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rastreadores",
      function () {
        return require("private-next-pages/rastreadores.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rastreadores"])
      });
    }
  